import { useCallback } from 'react';
import {
  useAnalyticsClient,
  useLinkClickedEvent,
} from '../../../../../utilities/analytics/analytics-web-client';
import { VERIFY_EMAIL_OTP_PAGE_ID } from '../constants';
import { useAppDispatch, useAppSelector } from '../../../../../stores/redux.store';
import { resendEmailOtp } from '../../../../../actions/verify-email-otp-actions';
import { useRegisterComponent } from '../../../../orchestrator';
import { useNavigateSoftOrHard } from '../../../../../utilities/hooks/useNavigateSoftOrHard';

type ResendEmailOtpHookProps = {
  onResend?: () => void;
};

export const useResendEmailOtp = ({ onResend }: ResendEmailOtpHookProps = {}) => {
  useRegisterComponent(useResendEmailOtp.name);

  const { redirectType } = useAppSelector(state => state.verifyEmailOtp);
  const dispatch = useAppDispatch();
  const analyticsClient = useAnalyticsClient();

  const trackResendEmailOtp = useLinkClickedEvent(VERIFY_EMAIL_OTP_PAGE_ID, 'resentEmailOtp', {
    signupType: redirectType,
    source: 'emailOtpScreen',
  });

  const navigate = useNavigateSoftOrHard();
  const onResendEmailOtp = useCallback(() => {
    onResend?.();
    trackResendEmailOtp();
    dispatch(resendEmailOtp(VERIFY_EMAIL_OTP_PAGE_ID, analyticsClient, navigate));
  }, [onResend, trackResendEmailOtp, dispatch, analyticsClient, navigate]);

  return { onResendEmailOtp };
};
